export default __webpack_public_path__ + "static/media/check-round.5493be03.svg";